import { useEffect, useState } from 'react'

interface UseDevPanelShortcut {
    isOpen: boolean
    close: () => void
}

export function useDevPanelShortcut(): UseDevPanelShortcut {
    const [isOpen, setIsOpen] = useState(false)

    useEffect(() => {
        if (typeof window === 'undefined') return

        const onKeyDown = (e: KeyboardEvent) => {
            if ((e.metaKey || e.ctrlKey) && e.shiftKey && e.key.toLowerCase() === 'f') {
                e.preventDefault()
                setIsOpen((prev) => !prev)
            }
        }

        window.addEventListener('keydown', onKeyDown)
        return () => window.removeEventListener('keydown', onKeyDown)
    }, [])

    return { isOpen, close: () => setIsOpen(false) }
}
